import { defineWave } from '../schema';

/** BLOC F2 — LE DÉMONTAGE. Le Bastion, répétition générale du dernier boss.
 *
 *  ── Sa fonction dans la campagne ──
 *  Ce bloc n'existe pas pour sa difficulté. Il existe pour que le joueur ait
 *  démonté trois ou quatre Bastions AVANT de voir le Colosse. Le mécanisme des
 *  parties destructibles s'y apprend au prix d'une erreur sans conséquence : un
 *  Bastion mal géré coûte quelques projectiles encaissés, là où la même
 *  hésitation devant un boss coûte une vie.
 *
 *  C'est l'ordre d'apprentissage correct, et il est rarement respecté : la
 *  plupart des jeux introduisent la destruction partielle directement sur un
 *  boss, où le joueur découvre simultanément le mécanisme, l'enjeu et la
 *  pression. Ici il l'a déjà vu trois fois quand ça compte.
 *
 *  ── Le premier Bastion arrive seul ──
 *  Huit secondes sans rien d'autre. Le joueur doit pouvoir observer qu'une
 *  tourelle détruite fait taire une arme — ce retour immédiat EST la leçon, et
 *  il est inaudible au milieu d'une vague.
 *
 *  ── Puis deux à la fois ──
 *  À 16 s, deux Bastions entrent ensemble à des abscisses opposées. Six
 *  tourelles simultanées dépassent ce qu'on peut raisonnablement démonter : le
 *  joueur doit choisir lesquelles, ou décider de viser les noyaux. C'est
 *  exactement l'arbitrage que le Colosse lui demandera, posé ici sur des cibles
 *  où se tromper ne coûte rien. */
export default defineWave({
  id: 'f2-demontage',
  duration: 32,
  spawns: [
    { at: 0.5, enemy: 'bastion', lane: 3, count: 1, spacing: 0 },
    // Rempart : bouclier frontal large (±80°). Seul d'abord — on découvre qu'il
    // faut le contourner, pas taper plus fort — dans la vague qui enseigne déjà
    // le démontage.
    { at: 4.0, enemy: 'rempart', lane: 3, count: 1, spacing: 0 },
    { at: 8.0, enemy: 'mite', lane: 1, count: 6, spacing: 0.08 },
    { at: 10.0, enemy: 'eclat', lane: 5, count: 3, spacing: 0.5 },
    // Char : noyau verrouillé, deux canons — le Bastion sans le choix, on DOIT
    // démonter. Couloir central (500 PV).
    { at: 12.0, enemy: 'char', lane: 3, count: 1, spacing: 0 },
    { at: 16.0, enemy: 'bastion', lane: 2, count: 1, spacing: 0 },
    { at: 16.6, enemy: 'bastion', lane: 4, count: 1, spacing: 0 },
    // Kyste : bulle à crever à 360° avant le noyau. Le Bastion apprend à casser
    // les parties, le Kyste applique la même leçon à une coque défensive.
    { at: 19.0, enemy: 'kyste', lane: 4, count: 1, spacing: 0 },
    { at: 21.0, enemy: 'dard', lane: 3, count: 4, spacing: 0.45 },
    // Couveur : source mobile qui sème des Spores stagnantes. Cible prioritaire
    // qu'ignorer coûte du terrain d'esquive (220 PV, couloir central).
    { at: 22.5, enemy: 'couveur', lane: 2, count: 1, spacing: 0 },
    { at: 24.0, enemy: 'mite', lane: 3, count: 9, spacing: 0.07 },
    { at: 27.0, enemy: 'egide', lane: 3, count: 1, spacing: 0 },
    { at: 29.5, enemy: 'faucheur', lane: 1, count: 1, spacing: 0 },
    { at: 29.9, enemy: 'faucheur', lane: 5, count: 1, spacing: 0 },
  ],
});
